module.exports = __webpack_public_path__ + "img/arrow-down-second.c2122714.svg";